module.exports = __webpack_public_path__ + "fonts/Intro-Black.otf?bcd0de1628c211715748ebc793c41138";